exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ThreeSensorIcons__ThreeSensorIcons__2FtCL {\n  width: 180px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  margin: 12px auto; }\n", ""]);

// exports
exports.locals = {
	"ThreeSensorIcons": "ThreeSensorIcons__ThreeSensorIcons__2FtCL"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/intro/components/ThreeSensorIcons/ThreeSensorIcons.scss
// module id = 520
// module chunks = 0